import { get } from 'lodash';
import * as R from 'remeda';
import { text, totalCountAggregationColumnField } from '../constants';
import { GridColumns } from './columns/types';
import { isNonEmptyObject } from './getProcessRowUpdate';
import { GridRowModel } from './rows/rowTypes';

type Aggregations = Record<string, Set<string>>;

export const getDataForAggregationRow = (
  columns: GridColumns,
  rows: GridRowModel[]
): Aggregations =>
  rows.reduce<Aggregations>(
    (aggregatedRowFieldSets, row) =>
      columns.reduce((aggregatedColumns, column) => {
        if (column.field === totalCountAggregationColumnField) {
          return aggregatedColumns;
        }

        const flatValue =
          // @ts-expect-error colDef and column mismatch
          column.valueGetter?.(undefined, row, column) ??
          get(row, column.field) ??
          null;

        const fieldSet = aggregatedColumns[column.field];

        const stringifiedFlatValue = isNonEmptyObject(flatValue)
          ? JSON.stringify(flatValue)
          : String(flatValue);

        return fieldSet !== undefined && flatValue !== text.cellNotEditable
          ? {
              ...aggregatedColumns,
              [column.field]: fieldSet.add(stringifiedFlatValue),
            }
          : aggregatedColumns;
      }, aggregatedRowFieldSets),
    {
      ...R.fromEntries(
        columns.map(column => [column.field, new Set<string>()])
      ),
      [totalCountAggregationColumnField]: new Set([String(rows.length)]),
    }
  );
